import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.625)} 
  ${viewSizeCalculator(0.7)} ${viewSizeCalculator(0.625)}`}; // 0.625rem
  margin: auto;

  width: 99%;
  height: auto;

  background-color: transparent;
`;

export const LogoContainer = styled.div`
  width: 17%;
  height: ${() => `${viewSizeCalculator(4.5)}`}; // 4.5rem
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`}; // 0.75rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  z-index: 101;
  cursor: pointer;
  svg {
    width: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
    height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
    cursor: pointer;
  }
`;

export const TextContaier = styled.div`
  cursor: pointer;
`;

export const Title = styled.p`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 900;
  line-height: ${() => `${viewSizeCalculator(1.21)}`}; // 1.21rem
  color: #333333;
`;

export const SubTitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  font-weight: 500;
  line-height: ${() => `${viewSizeCalculator(0.7562)}`}; // 0.7562rem
  color: #333333;
  opacity: 50%;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  width: 83%;
  height: ${() => `${viewSizeCalculator(4.5)}`}; // 4.5rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  padding: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  z-index: 101;
`;

export const BaseContainer = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`};
  height: ${() => `${viewSizeCalculator(3)}`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  border: ${() => `${viewSizeCalculator(0.125)} solid #3333331a`};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const BookmarkContainer = styled(BaseContainer)`
  background-color: ${(props) => (props.isPopupVisible ? "#f5f5f5" : "none")};
  border: ${(props) =>
    `${viewSizeCalculator(0.125)} solid ${props.isPopupVisible ? "#F99C89" : "none"}`};
`;

export const HospitalComparisonContainer = styled(BaseContainer)`
  /* border: ${(props) =>
    props.isTableVisible
      ? `${viewSizeCalculator(0.125)} solid rgba(249, 156, 137, 1)`
      : `${viewSizeCalculator(0.125)} solid #3333331a`};
  background-color: ${(props) => (props.isTableVisible ? "#f5f5f5" : "none")}; */
  border: ${(props) =>
    props.isTableVisible
      ? `${viewSizeCalculator(0.125)} solid rgba(249, 156, 137, 1)`
      : `${viewSizeCalculator(0.125)} solid #3333331a`};
  background-color: ${(props) => (props.isHovered || props.isTableVisible ? "#f5f5f5" : "none")};
`;

export const Badge = styled.div`
  width: ${() => `${viewSizeCalculator(1)}`};
  height: ${() => `${viewSizeCalculator(0.9)}`};
  position: absolute;
  top: -7.5%;
  right: -7.5%;
  border-radius: 50%;
  padding: ${() => `${viewSizeCalculator(0.5)}`};
  border: ${() => `${viewSizeCalculator(0.125)} solid #fff`};
  background-color: #e35b42;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  color: #fff;
`;

export const ProfileAndBookMarkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
`;

export const FilterBox = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  border: ${() => `${viewSizeCalculator(0.125)} solid #ebebeb`}; // 0.125rem
  background-color: #ffffff;

  position: relative;

  font-size: ${({ fontSize }) => `${viewSizeCalculator(fontSize || 1.5)}`}; // 1.5rem
  font-family: Inter;
  font-weight: 700;
  color: #ee3224;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  svg {
    width: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
    height: ${() => `${viewSizeCalculator(1.1875)}`}; // 1.1875rem
  }
`;

export const ProfileDetailsContainer = styled.div`
  width: ${() => `${viewSizeCalculator(22.5)}`};
  height: auto;
  padding: ${() => `${viewSizeCalculator(1.5)} 0`};
  position: absolute;
  top: ${() => `${viewSizeCalculator(4.4)}`};
  right: ${() => `-${viewSizeCalculator(10, true)}`};

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  box-shadow:
    0 ${() => `${viewSizeCalculator(0.0625)}`}
      ${() => `${viewSizeCalculator(0.3125)}`} #3333330a,
    0 ${() => `${viewSizeCalculator(0.125)}`}
      ${() => `${viewSizeCalculator(0.625)}`} #33333314,
    0 ${() => `${viewSizeCalculator(0.25)}`}
      ${() => `${viewSizeCalculator(1.25)}`} #3333331f;

  z-index: 10;

  transform: scaleY(${({ isVisible }) => (isVisible ? 1 : 0)});
  transform-origin: top right;

  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) =>
    isVisible ? "visible" : "hidden"};

  pointer-events: ${({ isVisible }) =>
    isVisible ? "auto" : "none"};

  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    visibility 0.2s ease;
`

export const InternalContainer = styled.div`
  width: ${() => `${viewSizeCalculator(19.5)}`}; //312px
  height: auto;

  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1.25)}`};
`
export const ContentContainer = styled.div`
  display:flex;
  gap:${() => `${viewSizeCalculator(0.75)}`};
`
export const ProfileAbbrBox = styled.div`
  width: ${() => `${viewSizeCalculator(3.375)}`};
  height: ${() => `${viewSizeCalculator(3.375)}`};
  padding: ${() => `${viewSizeCalculator(0.5625)}`};

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: ${() => `${viewSizeCalculator(1.4063)}`};
  border: ${() => `${viewSizeCalculator(0.1406)} solid #F96C50`};
  

  font-family: Inter;
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1.2656)}`};
  color: #FFFFFF;
  background-color: #F96C50;
`;

export const ProfileNameBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:${() => `${viewSizeCalculator(0.25)}`};
`

export const Details = styled.div`
 font-family: Inter;
 font-weight: ${({ fontWeight }) => fontWeight};
 font-size: ${({ fontSize }) => `${viewSizeCalculator(fontSize)}`};
 opacity: ${({ opacity }) => opacity};
`
export const Buttons = styled.div`
 width: ${() => `${viewSizeCalculator(9.375)}`};
 height: ${() => `${viewSizeCalculator(2.5)}`};
 padding : ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`};

 display:flex;
 align-items:center;
 justify-content:center;
 gap:${() => `${viewSizeCalculator(0.625)}`};

 border:${() => `${viewSizeCalculator(0.0625)} solid #333333`};
 border-radius:${() => `${viewSizeCalculator(1.25)}`};

 font-family: Inter;
 font-weight: 500;
 font-size: ${() => `${viewSizeCalculator(0.8125)}`};

 svg {
  width: ${() => `${viewSizeCalculator(1.5)}`}; 
  height: ${() => `${viewSizeCalculator(1.5)}`}; 
 }

 opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
 cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")}; 
   
 &:hover {
  border: ${({ isDisabled }) =>
    isDisabled
      ? `${viewSizeCalculator(0.0625)} solid #333333`
      : `${viewSizeCalculator(0.0625)} solid #E35B42`};
}
`

export const ReleaseNotesButton = styled(Buttons)`
 width: 100%;

 svg {
  width: ${() => `${viewSizeCalculator(1.25)}`};
  height: ${() => `${viewSizeCalculator(1.25)}`};
 }
`